import { InProgressScreen } from './inProgressScreen';

export const SetupAccountInProgress = () => {
  return (
    <InProgressScreen
      title='Getting things ready to move forward'
      description={`We're performing some operations in the background to prepare for the next step. You'll be able to continue as soon as everything is ready.`}
      src='/statics/images/illustrations/onboarding/eon-spaceship.mp4'
      alt={`Deploying Eon's scanning account`}
      size='large'
    />
  );
};
